export const DEMO_REPORT = {
    title: "Reporte Semanal - TechStore Argentina",
    generated_at: "2026-02-23T10:30:00Z",
    summary: "## Resumen Ejecutivo\n\nDurante la última semana, TechStore Argentina registró una **inversión total de $2.847.350** distribuida en Google Ads, Meta y TikTok, generando **1.284 conversiones** con un CPA promedio de $2.217. El ROAS general fue de **4.2x**, impulsado principalmente por las campañas de Google Shopping.\n\n- Google Ads lidera en volumen de conversiones con el mejor CPA\n- Meta muestra mejora sostenida en CPA (-5.1% vs semana anterior)\n- Tiendanube reportó ventas por $11.958.870 con ticket promedio de $13.407\n- El tráfico pago representa el 68% de los ingresos totales según GA4",
    branding: {
        logo_url: null,
        powered_by: "Dashbo"
    },
    blocks: [
        // === Sección: KPIs Principales ===
        {
            id: "sep-kpis",
            type: "separator",
            col_span: 12,
            data: {title: "KPIs Principales"}
        },
        {
            id: "kpi-inversion",
            type: "kpi_hero",
            col_span: 3,
            data: {
                rows: [{
                    metric: "Inversión Total",
                    value: 2847350,
                    format: "currency",
                    change: 12.3,
                    change_direction: "up",
                    change_sentiment: "neutral"
                }]
            }
        },
        {
            id: "kpi-conversiones",
            type: "kpi_hero",
            col_span: 3,
            data: {
                rows: [{
                    metric: "Conversiones",
                    value: 1284,
                    format: "number",
                    change: 8.7,
                    change_direction: "up",
                    change_sentiment: "positive"
                }]
            }
        },
        {
            id: "kpi-cpa",
            type: "kpi_hero",
            col_span: 3,
            data: {
                rows: [{
                    metric: "CPA Promedio",
                    value: 2217,
                    format: "currency",
                    change: -5.1,
                    change_direction: "down",
                    change_sentiment: "positive"
                }]
            }
        },
        {
            id: "kpi-roas",
            type: "kpi_hero",
            col_span: 3,
            data: {
                rows: [{
                    metric: "ROAS",
                    value: 4.2,
                    format: "number",
                    change: 15.2,
                    change_direction: "up",
                    change_sentiment: "positive"
                }]
            }
        },

        // === Sección: Rendimiento por Canal ===
        {
            id: "sep-canales",
            type: "separator",
            col_span: 12,
            data: {title: "Rendimiento por Canal"}
        },
        {
            id: "chart-inversion-canal",
            type: "bar_chart",
            col_span: 6,
            title: "Inversión por Plataforma",
            data: {
                rows: [
                    {plataforma: "Google Ads", costo: 1203450},
                    {plataforma: "Meta", costo: 1096580},
                    {plataforma: "TikTok", costo: 547320}
                ]
            }
        },
        {
            id: "table-canales",
            type: "table",
            col_span: 6,
            title: "Desglose por Canal",
            data: {
                rows: [
                    {canal: "Google Ads", costo: 1203450, clicks: 48230, cpa: 1890, conversiones: 637, ctr: 3.8},
                    {canal: "Meta", costo: 1096580, clicks: 62450, cpa: 2540, conversiones: 432, ctr: 1.9},
                    {canal: "TikTok", costo: 547320, clicks: 89120, cpa: 2545, conversiones: 215, ctr: 2.4}
                ],
                column_labels: {
                    canal: "Canal",
                    costo: "Inversión",
                    clicks: "Clicks",
                    cpa: "CPA",
                    conversiones: "Conversiones",
                    ctr: "CTR %"
                }
            }
        },
        {
            id: "text-canales-insight",
            type: "text",
            col_span: 12,
            data: {
                content: "**Google Ads** lidera en conversiones con un CPA 18% menor que Meta, principalmente impulsado por campañas de Shopping y Search. **Meta** tiene el mayor volumen de clicks pero un CPA más elevado — se recomienda optimizar audiencias lookalike. **TikTok** muestra buen engagement (CTR 2.4%) con costo competitivo, ideal para campañas de awareness."
            },
            ai_insight: {
                sentiment: "positive",
                observation: "El CPA general bajó 5.1% respecto a la semana anterior, indicando una mejora en la eficiencia de las campañas.",
                recommendation: "Considerar reasignar 10-15% del presupuesto de Meta hacia Google Shopping donde el CPA es significativamente menor."
            }
        },

        // === Sección: Tendencia Semanal ===
        {
            id: "sep-tendencia",
            type: "separator",
            col_span: 12,
            data: {title: "Tendencia Semanal"}
        },
        {
            id: "chart-gasto-diario",
            type: "line_chart",
            col_span: 6,
            title: "Gasto Diario por Canal",
            data: {
                rows: [
                    {fecha: "20260216", google_ads: 165200, meta: 148500, tiktok: 72100},
                    {fecha: "20260217", google_ads: 172400, meta: 155800, tiktok: 78900},
                    {fecha: "20260218", google_ads: 178100, meta: 162300, tiktok: 81200},
                    {fecha: "20260219", google_ads: 168900, meta: 158700, tiktok: 76400},
                    {fecha: "20260220", google_ads: 185600, meta: 165200, tiktok: 82300},
                    {fecha: "20260221", google_ads: 170300, meta: 152400, tiktok: 78500},
                    {fecha: "20260222", google_ads: 162950, meta: 153680, tiktok: 77920}
                ]
            }
        },
        {
            id: "chart-cpa-diario",
            type: "line_chart",
            col_span: 6,
            title: "CPA Diario por Canal",
            data: {
                rows: [
                    {fecha: "20260216", google_ads: 2050, meta: 2780, tiktok: 2690},
                    {fecha: "20260217", google_ads: 1980, meta: 2650, tiktok: 2610},
                    {fecha: "20260218", google_ads: 1920, meta: 2590, tiktok: 2580},
                    {fecha: "20260219", google_ads: 1850, meta: 2520, tiktok: 2540},
                    {fecha: "20260220", google_ads: 1810, meta: 2480, tiktok: 2510},
                    {fecha: "20260221", google_ads: 1870, meta: 2450, tiktok: 2490},
                    {fecha: "20260222", google_ads: 1890, meta: 2410, tiktok: 2470}
                ]
            }
        },
        {
            id: "text-tendencia-insight",
            type: "text",
            col_span: 12,
            data: {
                content: "El **CPA de Meta** muestra una tendencia descendente sostenida durante toda la semana, bajando de $2.780 a $2.410 (-13.3%). Google Ads se mantiene estable en el rango de $1.800-$2.050. TikTok también mejora gradualmente."
            },
            ai_insight: {
                sentiment: "positive",
                observation: "La tendencia descendente del CPA en Meta sugiere que las optimizaciones de audiencia están funcionando.",
                recommendation: "Mantener las audiencias actuales de Meta al menos 1 semana más antes de hacer cambios significativos."
            }
        },

        // === Sección: Google Analytics (GA4) ===
        {
            id: "sep-ga4",
            type: "separator",
            col_span: 12,
            data: {title: "Google Analytics (GA4)"}
        },
        {
            id: "metrics-ga4",
            type: "metric_card",
            col_span: 6,
            title: "Métricas de Sitio Web",
            data: {
                rows: [
                    {metric: "Sesiones", value: 45230, format: "number"},
                    {metric: "Usuarios", value: 28150, format: "number"},
                    {metric: "Tasa de Rebote", value: 42.3, format: "percentage"},
                    {metric: "Duración Promedio", value: 165, format: "number"}
                ]
            }
        },
        {
            id: "chart-ga4-revenue",
            type: "bar_chart",
            col_span: 6,
            title: "Ingresos por Canal de Adquisición",
            data: {
                rows: [
                    {canal_adquisicion: "Paid Search", ingresos: 4850200},
                    {canal_adquisicion: "Paid Social", ingresos: 3280450},
                    {canal_adquisicion: "Organic Search", ingresos: 2150800},
                    {canal_adquisicion: "Direct", ingresos: 1180300},
                    {canal_adquisicion: "Email", ingresos: 497120}
                ]
            }
        },
        {
            id: "text-ga4-insight",
            type: "text",
            col_span: 12,
            data: {
                content: "El tráfico pago genera el **68% de los ingresos totales** ($8.130.650 de $11.958.870). Organic Search aporta un 18% significativo, indicando buen posicionamiento SEO. La tasa de rebote del 42.3% está dentro del rango saludable para ecommerce."
            }
        },

        // === Sección: Ecommerce (Tiendanube) ===
        {
            id: "sep-ecommerce",
            type: "separator",
            col_span: 12,
            data: {title: "Ecommerce (Tiendanube)"}
        },
        {
            id: "kpi-ventas",
            type: "kpi_hero",
            col_span: 4,
            data: {
                rows: [{
                    metric: "Ventas Totales",
                    value: 11958870,
                    format: "currency",
                    change: 18.5,
                    change_direction: "up",
                    change_sentiment: "positive"
                }]
            }
        },
        {
            id: "kpi-pedidos",
            type: "kpi_hero",
            col_span: 4,
            data: {
                rows: [{
                    metric: "Pedidos",
                    value: 892,
                    format: "number",
                    change: 14.2,
                    change_direction: "up",
                    change_sentiment: "positive"
                }]
            }
        },
        {
            id: "kpi-ticket",
            type: "kpi_hero",
            col_span: 4,
            data: {
                rows: [{
                    metric: "Ticket Promedio",
                    value: 13407,
                    format: "currency",
                    change: 3.8,
                    change_direction: "up",
                    change_sentiment: "positive"
                }]
            }
        },
        {
            id: "metrics-ecommerce",
            type: "metric_card",
            col_span: 6,
            title: "Indicadores de Conversión",
            data: {
                rows: [
                    {metric: "Tasa de Conversión", value: 2.8, format: "percentage"},
                    {metric: "Abandono de Carrito", value: 67, format: "percentage"},
                    {metric: "Revenue por Sesión", value: 264, format: "currency"}
                ]
            }
        },
        {
            id: "table-ecommerce-channels",
            type: "table",
            col_span: 6,
            title: "Top 5 Canales de Adquisición",
            data: {
                rows: [
                    {canal: "Google Shopping", pedidos: 312, ingresos: 4185600, porcentaje_ingresos: 35.0},
                    {canal: "Facebook Ads", pedidos: 245, ingresos: 3287000, porcentaje_ingresos: 27.5},
                    {canal: "Google Search", pedidos: 148, ingresos: 1983960, porcentaje_ingresos: 16.6},
                    {canal: "Orgánico", pedidos: 125, ingresos: 1676250, porcentaje_ingresos: 14.0},
                    {canal: "TikTok Ads", pedidos: 62, ingresos: 826060, porcentaje_ingresos: 6.9}
                ],
                column_labels: {
                    canal: "Canal",
                    pedidos: "Pedidos",
                    ingresos: "Ingresos",
                    porcentaje_ingresos: "% del Total"
                }
            }
        },
        {
            id: "text-recomendaciones",
            type: "text",
            col_span: 12,
            data: {
                content: "## Recomendaciones\n\n- **Escalar Google Shopping**: Con el mejor ROAS y 35% de los ingresos, hay espacio para aumentar presupuesto 15-20%\n- **Optimizar Meta**: El CPA viene bajando — mantener la estrategia actual y testear nuevos creativos\n- **Mejorar checkout**: Con 67% de abandono de carrito, implementar remarketing dinámico y emails de recuperación\n- **Aprovechar orgánico**: El 14% de ingresos orgánicos indica buena autoridad de dominio — invertir en contenido SEO"
            },
            ai_insight: {
                sentiment: "positive",
                observation: "Las ventas crecieron 18.5% respecto a la semana anterior, con mejoras en todos los canales principales.",
                recommendation: "Priorizar la optimización del checkout para reducir el abandono del 67% — cada punto porcentual de mejora representa ~$178K en ingresos adicionales semanales."
            }
        }
    ]
};
